import React from 'react';

const DriverInfoSection = () => {
  return (
    <>
      <h6 className="fs-16 mb-3">Bem-vindo, motorista!</h6>
      <p className="mb-3">Aqui você poderá visualizar suas corridas, comissões e desempenho.</p>

      <div className="row">
        <div className="col-md-6 col-lg-4">
          <div className="card text-center p-3">
            <h6 className="fs-14 mb-1">Corridas Concluídas</h6>
            <p className="fw-bold text-success fs-20">124</p>
          </div>
        </div>

        <div className="col-md-6 col-lg-4">
          <div className="card text-center p-3">
            <h6 className="fs-14 mb-1">Comissões Totais</h6>
            <p className="fw-bold text-primary fs-20">R$ 3.450,00</p>
          </div>
        </div>

        <div className="col-md-6 col-lg-4">
          <div className="card text-center p-3">
            <h6 className="fs-14 mb-1">Avaliação Média</h6>
            <p className="fw-bold text-warning fs-20">4.8 ★</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverInfoSection;

